import controlPanelInitLogic from "./controlPanelInitLogic";
import loadMetadataLogic from "./loadMetadataLogic";

export default [...controlPanelInitLogic, ...loadMetadataLogic];
